export default __webpack_public_path__ + "static/media/Aircraft8-t.922e7284.png";